import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {

  constructor(private httpClientService:HttpClientService) { }

  async getHoliday(){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Holiday
    });
    return await firstValueFrom(observable);
  }
}
